import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

function Admin() {
  const [requests, setRequests] = useState([]);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const fetchAuthAndRequests = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        console.log('Session:', session);
        console.log('Sending token:', session.access_token); // Debug the token being sent
        const response = await fetch('/.netlify/functions/isAdmin', {
          headers: { Authorization: `Bearer ${session.access_token}` },
        });
        const data = await response.json();
        console.log('isAdmin Response:', data);
        setIsAuthorized(data.authorized);
      } else {
        console.log('No session found');
      }

      const { data, error } = await supabase
        .from('signup_requests')
        .select('*')
        .eq('status', 'pending');
      if (!error) {
        console.log('Fetched requests:', data);
        setRequests(data);
      } else {
        console.error('Error fetching requests:', error.message);
      }
    };

    fetchAuthAndRequests();
  }, []);

  if (!isAuthorized) {
    return <p>Not Authorized</p>;
  }

  const handleApprove = async (email) => {
    console.log('Approving user:', email); // Debug: Confirm function is called
    if (!email) {
      console.error('No email provided');
      alert('Error: No email provided');
      return;
    }
    try {
      const response = await fetch('/.netlify/functions/approveUser', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      console.log('Response status:', response.status); // Debug: Check HTTP status
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Approval failed');
      }
      setRequests((prev) => prev.filter((req) => req.email !== email));
    } catch (error) {
      console.error('Error approving user:', error.message);
      alert('Error approving user: ' + error.message); // Notify user of errors
    }
  };

  const handleDeny = async (id) => {
    const { error } = await supabase
      .from('signup_requests')
      .update({ status: 'denied' })
      .eq('id', id);
    if (!error) {
      setRequests((prev) => prev.filter((req) => req.id !== id));
    } else {
      console.error('Error denying request:', error.message);
      alert('Error denying request: ' + error.message); // Optional: Add for consistency
    }
  };

  return (
    <div>
      <h2>Pending Signup Requests</h2>
      {requests.map((request) => (
        <div key={request.id}>
          <p>{request.email}</p>
          <button onClick={() => handleApprove(request.email)}>Approve</button>
          <button onClick={() => handleDeny(request.id)}>Deny</button>
        </div>
      ))}
    </div>
  );
}

export default Admin;